import { Injectable, inject } from '@angular/core';
import { WarehouseMultimediaApiService } from '../api/services/warehouse-multimedia-api.service';
import { catchError, map, Observable, throwError } from 'rxjs';
import { AdminMultimediaDetails } from '@web/shared/module/multimedia';
import { Guid } from '@web/utils';
import { UploadException } from '@web/shared/ui';
import { HttpErrorService } from '@web/common';

@Injectable({
  providedIn: 'root',
})
export class WarehouseMultimediaDataSourceService {
  private readonly httpError = inject(HttpErrorService);
  /* prettier-ignore */
  private readonly warehouseMultimediaApi = inject(WarehouseMultimediaApiService);

  public fetchDetailsById(
    id: Guid,
    cacheable = false,
  ): Observable<AdminMultimediaDetails> {
    return this.warehouseMultimediaApi.fetchDetailsById(id, cacheable).pipe(
      map(
        (response) =>
          new AdminMultimediaDetails({
            alt: response.alt,
            canBeEdited: response.contextOperations.canBeEdited,
            canBeRemoved: response.contextOperations.canBeDeleted,
            createdAt: response.createdAt,
            description: response.description,
            extension: response.extension,
            filename: response.title,
            downloadUrl: response.downloadUrl,
            height: response.dimensions?.height,
            id: response.id,
            mimeType: response.mimeType,
            previewUrl: response.largeThumbUrl(),
            size: response.size,
            thumbnailPreviewUrl: response.miniThumbUrl(),
            type: response.type,
            width: response.dimensions?.width,
          }),
      ),
    );
  }

  public upload(file: File): Observable<Guid> {
    return this.warehouseMultimediaApi.upload(file).pipe(
      map((response) => response.id),
      catchError((response) =>
        throwError(
          () =>
            new UploadException(
              this.httpError.extract(response).multiLineMessages(),
            ),
        ),
      ),
    );
  }
}
